var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wl-pop-hover-container" }, [
    _c("div", { staticClass: "wl-pop-title-container" }, [
      _c("span", [_vm._v(_vm._s(_vm.data.row.title))]),
      _vm.showBtn
        ? _c("div", { staticClass: "wl-pop-icon-container" })
        : _vm._e(),
    ]),
    _c("div", { staticClass: "wl-pop-main-container" }, [
      _c("ul", [
        _c("li", [
          _c("span", [_vm._v(_vm._s(_vm.$t("TABLE_HEADER_ENTITIES")))]),
          _c("span", { attrs: { title: _vm.entityName } }, [
            _vm._v("\n          " + _vm._s(_vm.entityName) + "\n        "),
          ]),
        ]),
        _c("li", [
          _c("span", [_vm._v(_vm._s(_vm.$t("FORM_LABEL_kpmgOwner")))]),
          _c("span", [_vm._v(_vm._s(_vm.data.row.kpmgUserName))]),
        ]),
        _c("li", [
          _c("span", [_vm._v(_vm._s(_vm.$t("FORM_LABEL_clientOwner")))]),
          _c("span", [_vm._v(_vm._s(_vm.data.row.clientUserName))]),
        ]),
        _c("li", [
          _c("span", [_vm._v(_vm._s(_vm.$t("FORM_LABEL_status")))]),
          _c("span", [_vm._v(_vm._s(_vm.$t(_vm.getStatusLabel)))]),
        ]),
        _c("li", [
          _c("span", [_vm._v(_vm._s(_vm.$t("FORM_LABEL_priority")))]),
          _c("span", [_vm._v(_vm._s(_vm.$t(_vm.getPriorityLabel)))]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "wl-pop-bottom-container" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.$t("ACCOUNT_STATUS_CREATE_AT")) +
          " " +
          _vm._s(_vm._f("formatDate")(_vm.data.row.createDateStamp)) +
          "  " +
          _vm._s(_vm.$t("ACCOUNT_STATUS_SPREAD_BY")) +
          " " +
          _vm._s(_vm.data.row.createBy) +
          "\n    " +
          _vm._s(_vm.$t("ACCOUNT_STATUS_UPDATE_BY")) +
          " " +
          _vm._s(_vm._f("formatDate")(_vm.data.row.updateDateStamp)) +
          " " +
          _vm._s(_vm.$t("ACCOUNT_STATUS_SPREAD_BY")) +
          " " +
          _vm._s(_vm.data.row.updateBy) +
          "\n  "
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }